import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StatusHandler } from '../../../components'
import { fetchCities as fetcher } from '../slice'
import { citiesContext as context } from './context'

const NAME = 'cities'

const CitiesProvider = ({provinceId, children}) => {
  const dispatch = useDispatch()
  const _state = useSelector(state => state[NAME])
  const { status, error, data, data_options } = _state

  useEffect(() => {
    if(provinceId) dispatch(fetcher(provinceId))
  }, [dispatch, provinceId])

  return (
    <context.Provider value={{ [NAME]: data, options: data_options }}>
      <StatusHandler
        status={status}
        error={error}
        onRetry={() => dispatch(fetcher(provinceId))}
      >
        {children}
      </StatusHandler>
    </context.Provider>
  )
}

export { CitiesProvider }
